import { render, staticRenderFns } from "./ClientPartnerPasswordDialog.vue?vue&type=template&id=1cd72027&scoped=true&"
import script from "./ClientPartnerPasswordDialog.vue?vue&type=script&lang=ts&"
export * from "./ClientPartnerPasswordDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ClientPartnerPasswordDialog.vue?vue&type=style&index=0&id=1cd72027&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd72027",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VIcon})
